<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <button type="button" @click="cancelCamera" class="close-button">
                        <span aria-hidden="true" tabindex="-1">×</span>
                    </button>

                    <div class="modal-header">
                        <slot name="header">
                        </slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body" class="special-text">
                            <p style="margin-bottom: 0px"><b>Stregkode:</b> {{finalResult}}</p>
                            <p class="green-color" :class="{'visibility': !finalResult}" style="text-transform: uppercase">Stregkode på {{finalResult.length}} cifre scannet!</p>
                            <div id="interactive" class="viewport">
                                <video id="video"></video>
                                <div class="red-line"><hr /></div>
                            </div>
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <div class="grid-x">
                                <div class="small-6 cell" style="padding-right: 4px;">
                                    <a class="button" @click="cancelCamera" data-toggle="barcodeModal" aria-controls="barcodeModal">Annuller</a>
                                </div>
                                <div class="small-6 cell" style="padding-left: 4px;">
                                    <a class="button call-to-action" @click="stopCamera" data-toggle="barcodeModal" aria-controls="barcodeModal">Brug stregkode</a>
                                </div>
                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

import 'webrtc-adapter';
import { 
    BrowserMultiFormatReader, 
    BrowserBarcodeReader, 
    MultiFormatReader, 
    DecodeHintType,
    BarcodeFormat,
    Result,
    Exception} 
from '@zxing/library';

export default {
    name: 'modal',
    data() {
        return {
            lastResult: null,
            finalResult: "",
            codeReader: null
        }
    },
    methods: {
        stopCamera(e) {
            e.preventDefault();
            this.codeReader.reset()
            this.$emit("close", this.finalResult, false);
        },
        cancelCamera(e) {
            e.preventDefault();
            this.codeReader.reset()
            this.$emit("close", null, false);
        }
    },
    watch: {
        finalResult(val, oldVal) {
            if (oldVal != val) {
                console.log("oldVal", oldVal);
                console.log("val", val);
            }
        }
    },
    created() { },
    mounted() {
        try {
            var _this = this;
            $(document).foundation();

            const hints = new Map();
            hints.set(DecodeHintType.TRY_HARDER, true)

            const videoHtmlElementId = "video";
            const codeReader = new BrowserBarcodeReader()
            _this.codeReader = codeReader;

            codeReader.listVideoInputDevices()
                .then(devices => {
                    const handleDecodeResult = (result, error) => {
                        if (result) {
                            _this.finalResult = result.getText();
                        }
                    }
                    codeReader.decodeFromVideoDevice(
                        undefined, videoHtmlElementId, handleDecodeResult);
                });

        } catch (e) {
            console.log(e.message)
            _this.finalResult = e.message
        }
    }
}
</script>

<style lang="scss">
#interactive {
    position: relative;
}

.red-line {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 30;
    display: flex;
    justify-content: center;
    align-items: center;

    hr {
        border-color: red;
        border-width: 1px;
        z-index: 40000000000;
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// modal.vue?b339c4de